import { render, staticRenderFns } from "./TabsWithRoutesV2.vue?vue&type=template&id=5fab23ce"
import script from "./TabsWithRoutesV2.vue?vue&type=script&lang=ts"
export * from "./TabsWithRoutesV2.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/codebuild/output/src4020427597/src/jobbliss-app-vue/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('5fab23ce')) {
      api.createRecord('5fab23ce', component.options)
    } else {
      api.reload('5fab23ce', component.options)
    }
    module.hot.accept("./TabsWithRoutesV2.vue?vue&type=template&id=5fab23ce", function () {
      api.rerender('5fab23ce', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/components/common/TabsWithRoutesV2.vue"
export default component.exports